import EventBus from './../wirebox/event-bus'

const LoadingAnimation = {
    
    bindEvents() {

        EventBus.subscribe('loading.start', (element) => {
            element.addClass('loading')
        }).subscribe('loading.stop', (element) => {
            element.removeClass('loading')
        })
        
    }
    
}

LoadingAnimation.bindEvents()

export default LoadingAnimation